import { LitElement, html, nothing } from "lit";
import { fa, onceParentAvailable } from "../../../utils/widgets.js";
import {
	faChevronDown, faTags, faXmark
} from "@fortawesome/free-solid-svg-icons";
import { activeIcon } from "../../styles.js";

/**
 * Collapsible button showing off tags filters menus.
 * @class Panoramax.components.ui.widgets.SemanticsFiltersButton
 * @element pnx-widget-semantics-filters
 * @extends [lit.LitElement](https://lit.dev/docs/api/LitElement/)
 * @example
 * ```html
 * <pnx-widget-semantics-filters _parent=${viewer} />
 * ```
 */
export default class SemanticsFiltersButton extends LitElement {
	/** @private */
	static styles = [activeIcon];

	constructor() {
		super();
		onceParentAvailable(this).then(() => this._parent.onceMapReady?.().then(() => {
			this._parent?.mapStyleComposer?.addEventListener("dataoverlay-added", () => this.requestUpdate());
			this._parent?.map?.addEventListener("styledata", () => this.requestUpdate());
		}));
	}

	/** @private */
	render() {
		const o = this._parent.map?.getSemanticOverlays?.();
		if(!o || o.length === 0) { return; }

		const active = o.filter(l => l.metadata && this._parent.mapStyleComposer.dataOverlays.has(l.source)).length > 0;
		const isSmall = this._parent?.isWidthSmall() || this._parent?.isWidthMedium();
		const resetIcon = fa(faXmark, {styles: {"pointer-events": "auto"}});
		resetIcon.addEventListener("click", e => {
			e.stopPropagation();
			this._parent?.map?.toggleAllSemanticOverlays(false);
		});

		return html`
			<pnx-togglable-group
				id="pnx-widget-semantics-filter"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${fa(faTags)}
					${active ? html`<span class="pnx-active-icon"></span>` : nothing}
					${isSmall ? nothing : this._parent?._t.pnx.semantics_title}
					${isSmall ? nothing : (active ? resetIcon : fa(faChevronDown))}
				</pnx-button>
				<pnx-map-semantics-filters-menu
					id="pnx-map-semantics-filters-menu"
					._parent=${this._parent}
					@change=${this._onLayersChange}
				></pnx-map-semantics-filters-menu>
			</pnx-togglable-group>
		`;
	}
}

customElements.define("pnx-widget-semantics-filters", SemanticsFiltersButton);
